import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getWeeklyPracticeData } from '../../utils/streakCalculation';

const ProgressChart = ({ assessments }) => {
    const data = useMemo(() => getWeeklyPracticeData(assessments, 12), [assessments]);

    const avgPerWeek = useMemo(() => {
        if (data.length === 0) return 0;
        const total = data.reduce((sum, w) => sum + w.total, 0);
        return (total / data.length).toFixed(1);
    }, [data]);

    const hasData = data.some(w => w.total > 0);

    if (!hasData) {
        return (
            <div style={{
                padding: '30px',
                textAlign: 'center',
                color: '#999',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                marginBottom: '20px'
            }}>
                <div style={{ fontSize: '14px', fontFamily: 'Montserrat' }}>
                    No practice data yet. Complete your first session to see your progress chart!
                </div>
            </div>
        );
    }

    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            padding: '20px',
            marginBottom: '20px',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <div style={{
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#137fa2'
                }}>
                    Practice Trend (Last 12 Weeks)
                </div>
                <div style={{
                    fontFamily: 'Montserrat',
                    fontSize: '12px',
                    color: '#666',
                    backgroundColor: '#f0f7fa',
                    padding: '4px 10px',
                    borderRadius: '12px'
                }}>
                    Avg: <strong>{avgPerWeek}</strong> / week
                </div>
            </div>

            <ResponsiveContainer width="100%" height={220}>
                <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                    <XAxis
                        dataKey="week"
                        tick={{ fontSize: 10, fontFamily: 'Montserrat', fill: '#888' }}
                        axisLine={{ stroke: '#e0e0e0' }}
                        tickLine={false}
                    />
                    <YAxis
                        allowDecimals={false}
                        tick={{ fontSize: 10, fontFamily: 'Montserrat', fill: '#888' }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <Tooltip
                        contentStyle={{
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            borderRadius: '6px',
                            border: '1px solid #e0e0e0'
                        }}
                        labelStyle={{ fontWeight: 600, marginBottom: '4px' }}
                    />
                    <Legend
                        wrapperStyle={{ fontFamily: 'Montserrat', fontSize: '11px' }}
                        iconType="circle"
                        iconSize={8}
                    />
                    <Bar dataKey="Elevator Pitch" stackId="a" fill="#0784a7" radius={[0, 0, 0, 0]} />
                    <Bar dataKey="Casual Encounter" stackId="a" fill="#f59e0b" radius={[0, 0, 0, 0]} />
                    <Bar dataKey="Sales Presentation" stackId="a" fill="#10b981" radius={[2, 2, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ProgressChart;
